import { logoutUtility } from '../utility/logout.utility';

export async function post<
  Data,
  T extends Record<string, unknown> = Record<string, unknown>,
>(url: string, dataObject?: T, cookie?: string, logoutUtilityDisabled?: true) {
  const response = await fetch(url, {
    method: 'post',
    credentials: 'include',
    headers: cookie
      ? {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Cookie: cookie,
        }
      : {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
    body: JSON.stringify(dataObject),
  }).then(async (res) => {
    if (res.status === 422) {
      const parsed = await res.json();
      return Promise.reject(parsed);
    }
    return res;
  });

  if (response?.ok) {
    const responseBody: Data = await response.json();
    return responseBody;
  }

  if (response.status === 402) {
    const responseBody: Data = await response.json();
    return { ...responseBody, isSubscribed: false };
  }

  if (response?.status === 401 && !logoutUtilityDisabled) {
    logoutUtility();
    throw response;
  }

  throw response;
}

export async function get<
  Data,
  T extends Record<string, unknown> = Record<string, unknown>,
>(url: string, params?: T, cookie?: string, logoutUtilityDisabled?: true) {
  const query = new URLSearchParams(params as Record<string, string>).toString();
  const response = await fetch(`${url}?${query}`, {
    credentials: 'include',
    headers: cookie
      ? { Accept: 'application/json', Cookie: cookie }
      : { Accept: 'application/json' },
  });

  if (response.ok) {
    const responseBody: Data = await response.json();
    return responseBody;
  }

  if (response?.status === 401 && !logoutUtilityDisabled) {
    logoutUtility();
    throw response;
  }

  throw response;
}

export async function put<
  Data,
  T extends Record<string, unknown> = Record<string, unknown>,
>(url: string, dataObject?: T, logoutUtilityDisabled?: true) {
  const response = await fetch(url, {
    method: 'put',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(dataObject),
  });

  if (response.ok) {
    const responseBody: Data = await response.json();
    return responseBody;
  }

  if (response?.status === 401 && !logoutUtilityDisabled) {
    logoutUtility();
    throw response;
  }

  throw response;
}

export async function patch<
  Data,
  T extends Record<string, unknown> = Record<string, unknown>,
>(url: string, dataObject?: T, logoutUtilityDisabled?: true) {
  const response = await fetch(url, {
    method: 'patch',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(dataObject),
  });

  if (response.ok) {
    const responseBody: Data = await response.json();
    return responseBody;
  }

  if (response?.status === 401 && !logoutUtilityDisabled) {
    logoutUtility();
    throw response;
  }

  throw response;
}

export async function del<
  Data,
  T extends Record<string, unknown> = Record<string, unknown>,
>(url: string, logoutUtilityDisabled?: true, body?: Data) {
  const response = await fetch(`${url}`, {
    method: 'delete',
    credentials: 'include',
    headers: { Accept: 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });

  if (response.ok) {
    const responseBody: Data = await response.json();
    return responseBody;
  }

  if (response?.status === 401 && !logoutUtilityDisabled) {
    logoutUtility();
    throw response;
  }
  throw response;
}
